export default {
  'Text': '文字',
  'Styles': '樣式',
  'Text here': '在這裡輸入文字',
  'Add subtitles': '添加字幕',
  'Text Color': '文字顏色',
  'Outline': '外框',
  'Background': '背景',
  'Position': '位置',
}